import React, {  useEffect } from 'react';
import Datas from '../../data/testimonials/comments.json';
import { Container, Row, Col, Card } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/testimonial.js';
import axios from 'axios';
import { useDispatch, useSelector, connect } from 'react-redux';
import { getTestimonials, showLoading, hideLoading } from '../../redux/actions/testimonial';


const ClientsTestimonial = () => {
    // componentDidMount(){
    //     document.title = "Clients Testimonial | REAL FM";
    // }

    const testimonials = useSelector(state => state.allTestimonials.testimonials);

    const dispatch = useDispatch();

    useEffect(() => {
        document.title = "Our Experience | REAL FM";
    },[]);


    useEffect(() => {
        const fetchAllTestimonials = async () => {
            dispatch(showLoading());
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/testimonials/find-all`).then((res) => {
                dispatch(getTestimonials(res.data));
                dispatch(hideLoading());

            }).catch(error => {
                console.error(error);
            });
        };
        fetchAllTestimonials();
    }, [dispatch]);


        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper event-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Clients Testimonial" />

                    {/* ClientsTestimonial Area */}
                    <section className="event-page-area">
                    <Container className="card custom-card">
                            <Row>
                                <Col lg="12" md="12">
                                    {
                                        testimonials !== null && testimonials.length > 0 ? testimonials.map((data, i) => (
                                            <div className="event-box" key={i}>
                                                <Row>
                                                   
                                                    <Col >
                                                        <Card>
                                                            <Card.Body>
                                                                <Row>
                                                                    <Col lg={1} md={2} sm={12} className="client-image">
                                                                        {/* <img src={process.env.PUBLIC_URL + "/assets/images/" + data.authorImg} alt="" /> */}
                                                                        <img src={process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `${data.authorImg.substring(data.authorImg.indexOf("/uploads"))}`} alt={data.testimonialTitle} />
                                                                    </Col>
                                                                    <Col lg={11} md={9} sm={12}>
                                                                        <Card.Title style={{ color: '#00B4F5' }}>{data.testimonialTitle}</Card.Title>
                                                                        <Card.Text>
                                                                        {data.testimonialDesc}
                                                                        </Card.Text>
                                                                        <Card.Text>
                                                                        <strong>- {data.authorName}</strong>
                                                                        </Card.Text>
                                                                    </Col>
                                                                </Row>

                                                                
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )): "No testimonial found"
                                    }

                                </Col>
                            </Row>
                        </Container>
                    </section>


                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
}

export default ClientsTestimonial